<template>
	<div class="Index">
		<div class="case-pice"><span class="case-pice-first">专业类别管理</span> <span class="case-pice-and">/</span> <span class="case-pice-second">首页</span></div>
		<div>
			<div class="commom-input-label">专业类别名称：</div>
			<el-input v-model="searchData.name" class='common-input-width' size='small' placeholder="请输入专业类别名称"></el-input>
			<el-button size='small' type="primary" style="margin-left: 10px;font-size: 14px;" @click='search()' plain icon="el-icon-search">查询</el-button>
			<el-button size='small' type="primary" style="margin-left: 10px;font-size: 14px;float: right;margin-top: 15px;" @click='editMajor("add")' plain icon="el-icon-circle-plus-outline">添加专业类别</el-button>
		</div>
		<el-table :data="tableData" border style="width: 100%" stripe height=' calc(100vh - 210px)'>
			<el-table-column label="序号" width="60">
				<template slot-scope="scope">
					{{scope.$index+1}}
				</template>
			</el-table-column>
			<el-table-column prop="codeCname" show-overflow-tooltip label="专业类别名称">
			</el-table-column>
			<el-table-column prop="codeCode" show-overflow-tooltip label="类别编号">
			</el-table-column>
			<el-table-column prop="updateTime" show-overflow-tooltip label="更新时间">
				<!--<template slot-scope="scope">
					<span>{{scope.row.updateTime.year}}-{{scope.row.updateTime.monthValue | filterTime}}-{{scope.row.updateTime.dayOfMonth | filterTime}}</span>
					<span style="margin-left: 10px;">{{scope.row.updateTime.hour | filterTime}}:{{scope.row.updateTime.minute | filterTime}}:{{scope.row.updateTime.second | filterTime}}</span>
				</template>-->
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="160">
				<template slot-scope="scope">
					<el-button size='mini' type="primary" @click='editMajor("update",scope.row)' plain>编辑</el-button>
					<el-button size='mini' type="danger" @click='deleteMajor(scope.row)' plain>删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination-block">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNumber">
			</el-pagination>
		</div>
		<el-dialog :title="majorModelTile" :visible.sync="centerDialogVisible" v-if='centerDialogVisible' width="400px" center>
			<div style="display: flex;height: 60px;line-height: 60px;">
				<div class="commom-input-label">专业类别名称：</div>
				<el-input v-model="professional.professionalName" style='flex: 1;' size='small' placeholder="请输入专业类别名称"></el-input>
			</div>
			<div style="display: flex;height: 60px;line-height: 60px;">
				<div class="commom-input-label">类别编码：</div>
				<el-input v-model="professional.professionalCode" style='flex: 1;' size='small' placeholder="请输入类别编码"></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size='small' @click="centerDialogVisible = false">取 消</el-button>
				<el-button size='small' type="primary" plain @click="saveMajor()">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { majorTypeList, getMajorDetail, addMajorDetail, deleteMajorDetail } from '../../api/main'
	export default {
		name: 'Index',
		mounted() {
			let username = sessionStorage.getItem('username')
			if(!username) {
				this.$router.push('/Login');
			}
			this.getMajorDataList();
		},
		activated(){
			let username = sessionStorage.getItem('username')
			if(!username) {
				this.$router.push('/Login');
			}
			this.getMajorDataList();
		},
		data() {
			return {
				searchData: {
					name: '',
					code: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				totalNumber: 0,
				centerDialogVisible: false,
				majorModelTile: '',
				professional: {
					professionalName: '',
					professionalCode: ""
				},
				nowModelType: '',
				nowModelId: '',
			}
		},
		methods: {
			getMajorDataList() {
				majorTypeList({
					current: this.currentPage,
					pageSize: this.pageSize,
					professionalName: this.searchData.name
				}).then(res => {
					this.tableData = res.data.records;
					this.totalNumber = parseInt(res.data.total);
				})
			},
			search() {
				this.currentPage = 1;
				this.getMajorDataList();
			},
			handleSizeChange(data) {
				this.pageSize = data;
				this.getMajorDataList();
			},
			handleCurrentChange(data) {
				this.currentPage = data;
				this.getMajorDataList();
			},
			editMajor(pageType, row) {
				this.nowModelType = pageType;
				if(pageType == 'add') {
					this.majorModelTile = '添加专业类别';
					this.professional.professionalName = '';
					this.professional.professionalCode = '';
				} else {
					this.nowModelId = row.id;
					this.majorModelTile = '修改专业类别';
					this.professional.professionalName = row.codeCname;
					this.professional.professionalCode = row.codeCode;
				}
				this.centerDialogVisible = true;
			},
			saveMajor() {
				if(this.nowModelType == 'add') {
					addMajorDetail(this.professional).then(res => {
						console.log(res)
						if(res.code == 1) {
							this.$message({
								type: 'success',
								message: '新增成功！'
							});
							this.centerDialogVisible = false;
							this.getMajorDataList();
						} else {
							this.$message({
								type: 'error',
								message: res.msg + '请重新输入！'
							});
						}
					})
				} else {
					this.professional.professionalId = this.nowModelId;
					addMajorDetail(this.professional).then(res => {
						console.log(res)
						if(res.code == 1) {
							this.$message({
								type: 'success',
								message: '修改成功！'
							});
							this.centerDialogVisible = false;
							this.getMajorDataList();
						} else {
							this.$message({
								type: 'error',
								message: res.msg + '请重新输入！'
							});
						}
					})
				}
			},
			deleteMajor(row) {
				this.$confirm('此操作将永久删除该专业类别, 是否继续?', '删除专业类别', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteMajorDetail(row.id).then(res => {
						console.log(res)
						if(res.code == 1) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getMajorDataList();
						}else{
							this.$message({
								type: 'error',
								message:res.msg
							});
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	}
</script>
<style lang='less'>
	.el-table {}
</style>